import styled from 'styled-components';

const Container = styled.div`
  min-height: calc(100vh - 180px);
  padding: 0 15px;
`;

export { Container };
